import { Classes as BlueprintClasses } from '@blueprintjs/core';
import { ItemListRendererProps as BlueprintItemListRendererProps } from '@blueprintjs/select';
import classNames from 'classnames';
import * as React from 'react';
import {
  FixedSizeListProps,
  FixedSizeList as _FixedSizeList,
} from 'react-window';

import { SelectItem } from 'bones/design-system/utils/select/types';

export type VirtualizedRendererOptions = {
  listRef: React.MutableRefObject<_FixedSizeList | null>;
  noResults: JSX.Element;
};

const FixedSizeList: React.FunctionComponent<FixedSizeListProps> =
  _FixedSizeList as any;

export const virtualizedRenderer =
  <
    SubItemType extends SelectItem | null,
    ItemType extends SelectItem<SubItemType>
  >({
    listRef,
    noResults,
  }: VirtualizedRendererOptions) =>
  // eslint-disable-next-line react/display-name
  (itemListProps: BlueprintItemListRendererProps<ItemType>) => {
    // call renderItem inside the FixedSizeList virtual callback instead of
    // inside renderFilteredItems which calls it for every item
    const { filteredItems, renderItem } = itemListProps;

    return (
      <FixedSizeList
        // @ts-ignore
        ref={listRef}
        className={classNames(
          'vb-menu-items',
          'vb-menu-items--virtualized',
          BlueprintClasses.MENU
        )}
        height={Math.min((filteredItems.length || 1) * 30, 300)}
        itemCount={filteredItems.length || 1}
        itemSize={30}
        overscanCount={15}
        width="100%"
      >
        {(listProps: { index: number; style: React.CSSProperties }) => (
          <div style={listProps.style}>
            {filteredItems.length > 0
              ? renderItem(filteredItems[listProps.index], listProps.index)
              : noResults}
          </div>
        )}
      </FixedSizeList>
    );
  };
